<script lang="ts">
  import { DropdownMenu as DropdownMenuPrimitive } from "bits-ui"

  let { ...restProps }: DropdownMenuPrimitive.PortalProps = $props()
</script>

<DropdownMenuPrimitive.Portal {...restProps}/>
